import { createSelector } from 'reselect';
import { get, map, filter, unescape } from 'lodash';

import { domainsByIdSelector } from '../../common/selectors/domains-selectors';


import {
    claimedParentDomainsWithCountsSelector,
    claimedSubdomainsWithCountsSelector
} from '../../common/selectors/claimed-domains-with-counts-selectors';
import { domainGroupsByIdSelector } from '../../common/selectors/domain-groups-selectors';

export const claimedDomainHierarchyParamSelector = ( state ) => get( state, 'claimedDomainsWithCounts.params.domainHierarchy', null );

export const claimedParentDomainsTableDataSelector = createSelector(
    claimedParentDomainsWithCountsSelector,
    domainGroupsByIdSelector,
    ( parentDomains, allDomainGroupIds ) => {
        return map( parentDomains, domain => {
            const dmarcStatusPolicy = get( domain, 'dmarc.statusPolicy', null );
            const subdomainPolicy = get( domain, 'dmarc.subdomainPolicy', null );

            return {
                claimedDate: domain.dateApproved,
                dmarcPolicy: dmarcStatusPolicy,
                domainGroups: map( domain.domainGroups, ( groupId ) =>  unescape( get( allDomainGroupIds[groupId], 'name', '' ) ) ),
                domainName: domain.domainName,
                domainType: domain.domainType,
                lastPolicyChange: domain.lastDmarcPolicyChangeDate,
                subdomainPolicy,
                totalVolume: domain.totalMailCount,
            };
        } );
    }
);

export const claimedSubdomainsTableDataSelector = createSelector(
    claimedSubdomainsWithCountsSelector,
    domainGroupsByIdSelector,
    ( subdomains, allDomainGroupIds ) => {
        return map( subdomains, domain => {
            const dmarcPolicy = get( domain, 'dmarc.statusPolicy', null );

            return {
                claimedDate: domain.dateApproved,
                dmarcPolicy,
                dmarcPolicyInherited: get( domain, 'dmarc.policyInherited', 'none' ),
                domainGroups: map( domain.domainGroups, ( groupId ) =>  unescape( get( allDomainGroupIds[groupId], 'name', '' ) ) ),
                domainName: domain.domainName,
                domainType: domain.domainType,
                lastPolicyChange: domain.lastDmarcPolicyChangeDate,
                totalVolume: domain.totalMailCount,
            };
        } );
    }
);

export const claimedSubdomainsOrgDomainsSelector = createSelector(
    domainsByIdSelector,
    ( allDomains ) => {
        const orgDomains = filter( allDomains, ( domain ) =>
            domain.orgDomain && domain.domainName !== domain.orgDomain )
            .map( domain => domain.orgDomain );

        return [ ...new Set( orgDomains ) ].sort();
    }
);
